'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PROMO_BANNER_THEMES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = PromoBanner;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _propTypesElementtype = require('prop-types-elementtype');

var _propTypesElementtype2 = _interopRequireDefault(_propTypesElementtype);

var _reactProptypeConditionalRequire = require('react-proptype-conditional-require');

var _reactProptypeConditionalRequire2 = _interopRequireDefault(_reactProptypeConditionalRequire);

var _ArrowRight = require('@deliveroo/icon-set/react/ArrowRight');

var _ArrowRight2 = _interopRequireDefault(_ArrowRight);

var _Cross = require('@deliveroo/icon-set/react/Cross');

var _Cross2 = _interopRequireDefault(_Cross);

var _mergeProps = require('../../utils/mergeProps');

var _mergeProps2 = _interopRequireDefault(_mergeProps);

var _banners = require('../../utils/banners');

var _Heading = require('../Heading');

var _Heading2 = _interopRequireDefault(_Heading);

var _P = require('../P');

var _P2 = _interopRequireDefault(_P);

var _Button = require('../Button');

var _Button2 = _interopRequireDefault(_Button);

var _SpacerElement = require('../../internal/SpacerElement');

var _SpacerElement2 = _interopRequireDefault(_SpacerElement);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = {
  'wrapper': 'ccl-84c394d16c1bf988',
  'banner': 'ccl-dc96c6fb871bcdb3',
  'row': 'ccl-bd8208017e1cf3b3',
  'clickable': 'ccl-a0139552031c7717',
  'withIcon': 'ccl-4f07029a112cf4c6',
  'placeholder': 'ccl-92379ba9da2d30de',
  'teal': 'ccl-fcb5751ab4859f8a',
  'berry': 'ccl-e57a2b093615f4e2',
  'purple': 'ccl-a9d721751ba1b6c3',
  'content': 'ccl-276bda817a7bcaf2',
  'buttonWrapper': 'ccl-1097b1f6b4a24175',
  'button': 'ccl-5e81255834253e41',
  'text': 'ccl-e079a7aacee66161',
  'textContent': 'ccl-7e4aea6e27ca7aa6'
};
var PROMO_BANNER_THEMES = exports.PROMO_BANNER_THEMES = ['teal', 'purple', 'berry'];

/**
 * A banner for marketing and promotional purposes — should only be used for
 * Deliveroo-branded content. See also: ServiceBanner, which has a nearly
 * identical implementation for service-related messages.
 */
function PromoBanner(originalProps) {
  var isPlaceholder = originalProps.isPlaceholder;

  var props = isPlaceholder ? (0, _mergeProps2.default)(originalProps, PromoBanner.placeholderProps) : originalProps;
  var title = props.title,
      body = props.body,
      icon = props.icon,
      theme = props.theme,
      href = props.href,
      shouldOpenInNewWindow = props.shouldOpenInNewWindow,
      isMobileRow = props.isMobileRow,
      buttonLabel = props.buttonLabel,
      onClick = props.onClick,
      hasCloseButton = props.hasCloseButton;


  var hasButton = !!buttonLabel && onClick;
  var isClickable = !hasButton && (href || onClick);
  var actionIcon = hasCloseButton ? _Cross2.default : _ArrowRight2.default;

  var _linkOrButton = (0, _banners.linkOrButton)({ href: href, onClick: onClick, hasButton: hasButton, shouldOpenInNewWindow: shouldOpenInNewWindow }),
      _linkOrButton2 = _slicedToArray(_linkOrButton, 2),
      Element = _linkOrButton2[0],
      elementProps = _linkOrButton2[1];

  var bannerClassNames = (0, _banners.getBannerClassNames)({
    styles: styles,
    theme: theme,
    isClickable: isClickable,
    hasIcon: !!icon,
    isMobileRow: isMobileRow,
    isPlaceholder: isPlaceholder
  });

  var actionIconColor = theme === 'white' ? 'teal' : 'white';
  var headingColor = theme === 'white' ? 'black' : 'white';
  var textColor = theme === 'white' ? 'grey' : 'white';

  return _react2.default.createElement(
    _SpacerElement2.default,
    {
      element: 'div',
      spacing: props.spacing,
      className: styles.wrapper,
      adjacentVerticalSpacing: props.adjacentVerticalSpacing,
      adjacentHorizontalSpacing: props.adjacentHorizontalSpacing,
      isPlaceholder: isPlaceholder
    },
    _react2.default.createElement(
      Element,
      _extends({}, elementProps, { className: bannerClassNames }),
      _react2.default.createElement(
        'div',
        { className: (0, _classnames3.default)(styles.content, _defineProperty({}, styles.button, hasButton)) },
        _react2.default.createElement(
          _SpacerElement2.default,
          { className: styles.text, adjacentHorizontalSpacing: 'medium' },
          _react2.default.createElement(
            'div',
            { className: styles.textContent },
            icon && _react2.default.createElement(_Icon2.default, { component: icon, color: textColor, size: 24, spacing: '0 small 0 0' }),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _Heading2.default,
                { color: headingColor, level: 4, size: 'x-small' },
                title
              ),
              _react2.default.createElement(
                _P2.default,
                { color: textColor, size: 'small', adjacentVerticalSpacing: 'x-small' },
                body
              )
            )
          )
        ),
        isClickable && _react2.default.createElement(_Icon2.default, {
          component: actionIcon,
          size: 24,
          adjacentHorizontalSpacing: 'small',
          color: actionIconColor
        }),
        hasButton && _react2.default.createElement(
          'span',
          { className: styles.buttonWrapper },
          _react2.default.createElement(
            _Button2.default,
            {
              size: 'small',
              onClick: onClick,
              href: href,
              type: 'secondary',
              isInverted: theme !== 'white',
              newWindow: shouldOpenInNewWindow
            },
            buttonLabel
          )
        )
      )
    )
  );
}

PromoBanner.displayName = 'PromoBanner';
PromoBanner.propTypes = _extends({
  /**
   * Title text for the banner
   */
  title: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.string, function (_ref) {
    var isPlaceholder = _ref.isPlaceholder;
    return !isPlaceholder;
  }),

  /**
   * Body text of the banner
   */
  body: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.string, function (_ref2) {
    var isPlaceholder = _ref2.isPlaceholder;
    return !isPlaceholder;
  }),

  /**
   * Optional icon to display alongside the title text
   */
  icon: _propTypesElementtype2.default,

  /**
   * The banner’s colour theme
   */
  theme: _propTypes2.default.oneOf(PROMO_BANNER_THEMES),

  /**
   * An optional hyperlink URL
   */
  href: _propTypes2.default.string,

  /**
   * An onClick event handler
   */
  onClick: _propTypes2.default.func,

  /**
   * Should the icon accompanying an onClick handler be a cross (i.e. close button)?
   */
  hasCloseButton: _propTypes2.default.bool,

  /**
   * Should the hyperlink be opened in a new window?
   */
  shouldOpenInNewWindow: _propTypes2.default.bool,

  /**
   * Is the PromoBanner being rendered in a row style on mobile (i.e. without rounded corners)
   */
  isMobileRow: _propTypes2.default.bool

}, _SpacerElement2.default.propTypes);

PromoBanner.defaultProps = _extends({
  title: undefined,
  body: undefined,
  icon: undefined,
  theme: 'teal',
  href: undefined,
  shouldOpenInNewWindow: false,
  isMobileRow: false,
  onClick: undefined,
  hasCloseButton: false
}, _SpacerElement2.default.defaultProps);

PromoBanner.placeholderProps = {
  title: 'placeholder',
  body: 'placeholder'
};